import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Sep 26 2018
 * @author PKl
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { CompetitorsPriorityConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import { default as logger } from '../../../shared/logger';
import api from '../../api';
import { CRUTransportLayer } from '../CRUTransportLayer';
export var CompetitorsPriorityLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(CompetitorsPriorityLayer, _CRUTransportLayer);

  function CompetitorsPriorityLayer() {
    _classCallCheck(this, CompetitorsPriorityLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorsPriorityLayer).call(this, CONSTANTS.API.ENDPOINTS.COMPETITORS_PRIORITY));
  }

  _createClass(CompetitorsPriorityLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.competitorsPriorityConverter;
    }
    /**
     * Fletches list of competitors
     */

  }, {
    key: "findAllCompetitors",
    value: function findAllCompetitors() {
      var getAllCompetitors = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.COMPETITORS)).get({
        responseType: 'json'
      }).then(function (response) {
        var competitors = [];
        (response.data.result || []).map(function (competitor) {
          competitors.push(competitor);
        });
        return competitors;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return getAllCompetitors;
    }
    /**
     * Method deletes Competitor Priority
     * @param id -  id of Priority that you want to delete
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      var deletePromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.COMPETITORS_PRIORITY, "/").concat(id)).delete({
        responseType: 'json'
      }).then(function (response) {
        return response.data.deleted === true;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return deletePromise;
    }
  }]);

  return CompetitorsPriorityLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", CompetitorsPriorityConverter)], CompetitorsPriorityLayer.prototype, "competitorsPriorityConverter", void 0);